import axios from "axios";

export const httpAxios= axios.create({
  // baseURL: "https://limoapi.dev-mn.xyz/api",
  baseURL: "https://limoapi.dev-mn.xyz/api",

})

httpAxios.interceptors.request.use((res)=>{

  if(res){

      res.headers.Authorization="Bearer " +localStorage.getItem('token');
  }
  
  return res;
},(err)=>{
  console.log("intercepter reposne",err.response.data.message)
  if(err.response.data.message==="Unauthenticated"){
  
     
    localStorage.removeItem('token');
   

  }
  throw err
})